import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from './firebase';

const toPublicJeweller = (doc) => {
  const data = doc.data();
  const fullName = [data.firstName, data.surname].filter(Boolean).join(' ').trim();
  const location = data.location || data.town || data.tags?.town || '';
  const intro = (data.introParagraph || '').trim();
  const bio = (data.bio || '').trim();

  return {
    id: doc.id,
    companyName: data.companyName || 'Jeweller on Boutee',
    fullName: fullName || 'Independent jeweller',
    location,
    profilePhoto: data.profilePhoto || data.brandIcon || '',
    website: data.website || '',
    instagram: data.instagram || '',
    introParagraph: intro,
    bio,
    summary: intro || bio || 'Live on Boutee'
  };
};

export const fetchActiveCommunityJewellers = async () => {
  const jewellersQuery = query(
    collection(db, 'jewellers'),
    where('active', '==', true)
  );

  const snapshot = await getDocs(jewellersQuery);

  return snapshot.docs
    .map(toPublicJeweller)
    .filter((jeweller) => jeweller.companyName);
};

export const shuffleJewellers = (jewellers) => {
  const copy = [...jewellers];

  for (let index = copy.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [copy[index], copy[randomIndex]] = [copy[randomIndex], copy[index]];
  }

  return copy;
};
